import { useEffect } from 'react';

import { apiGetSpeechAudio } from 'core/api';

import { useSafeState } from './lifeCycle';

export const useAudioBlob = (wordUid: string): string | null => {
  const [state, setState] = useSafeState<{
    wordUid: string;
    url: string | null;
  }>({
    wordUid,
    url: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    let promise = cache.get(wordUid);
    if (!promise) {
      promise = fetchWordAudio(wordUid);
      cache.set(wordUid, promise);
    }

    promise
      .then(url => {
        if (!signal.aborted) {
          setState({ wordUid, url });
        }
      })
      .catch(console.warn);

    return () => controller.abort();
  }, [wordUid]);

  return state.wordUid === wordUid ? state.url : null;
};

const cache = new Map<string, Promise<string>>();

const fetchWordAudio = (wordUid: string): Promise<string> =>
  fetch(apiGetSpeechAudio(wordUid)).then(async (response): Promise<string> => {
    if (!response.ok) {
      throw new Error(`Could not synthesize a word`);
    }

    const buffer = await response.arrayBuffer();
    const blob = new Blob([buffer], {
      type: response.headers.get('content-type') ?? 'audio/mpeg',
    });
    return URL.createObjectURL(blob);
  });
